require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-graduate-business-development-executive.json") })
        }
      }, "path---careers-graduate-business-development-executive");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-graduate-business-development-executive!./.cache/json/careers-graduate-business-development-executive.json
// module id = 864
// module chunks = 231608221292675